import {BookingSessionStorageKeys} from "./booking-session-storage-keys";
import {EmbeddedStorage, EmbeddedStorageOptions} from "../../../storage/embedded-storage";
import {UserSessionStorageKeys} from "../../../storage/user-session-storage/user-session-storage-keys";
import {IUserSessionStorageService} from "../../../storage/user-session-storage/user-session-storage.service.interface";

function createEmbeddedStorageOptions(token: string, userSessionStorage?: IUserSessionStorageService): EmbeddedStorageOptions<UserSessionStorageKeys> | undefined {
    if(userSessionStorage) {
        return {
            parentStorage: userSessionStorage,
            parentStorageKey: UserSessionStorageKeys.BookingSessionStorage,
            getStorageDiscriminator: () => token
        }
    }
    return undefined;
}

export class BookingSessionStorage extends EmbeddedStorage<BookingSessionStorageKeys, UserSessionStorageKeys> {
    constructor(token: string, sessionStorage?: IUserSessionStorageService) {
        super(createEmbeddedStorageOptions(token, sessionStorage));
    }

}
